import { OrganizationGISSetup } from 'types/graphql'

import { useMyOrgGisSetup } from 'src/layouts/AppStateContextLayout/utils'
import { useIsApprovalConditionsEnabled } from 'src/utils/featureFlagging/featureFlagging'

type UseShowConditionsUiProps = {
  /**
   * GIS mode for the org that owns the current UI context (e.g. entity/record/meeting).
   * Resolved as `props?.organizationGisSetup ?? sessionOrgGisSetup`: nullish values fall back to the
   * signed-in user's active org (`useMyOrgGisSetup`). Omit `props` entirely for session-only behavior.
   */
  organizationGisSetup?: OrganizationGISSetup | null
}

/** Statsig Approval Conditions + Entity Versions GIS (parcel/address Conditions tab + related UI). */
const useShowConditionsUi = (props?: UseShowConditionsUiProps): boolean => {
  const isApprovalConditionsEnabled = useIsApprovalConditionsEnabled()
  const sessionOrgGisSetup = useMyOrgGisSetup()
  const orgGisSetup = props?.organizationGisSetup ?? sessionOrgGisSetup
  return isApprovalConditionsEnabled && orgGisSetup === 'EntityVersions'
}

export default useShowConditionsUi
